module.exports = __webpack_public_path__ + "assets/img/help_pagination04-3.1b4f3fb6.svg";